import { IKyHieuHoaDon } from "../../model/respone/hoa-don-dien-tu/IKyHieuHoaDon";
import { apiClient } from "../apiClient";
export const KY_HIEU_HOA_DON_ENDPOINT = "ky-hieu-hoa-don";
export const kyHieuHoaDonApi = {
  SelectAll: () => apiClient.get(`${KY_HIEU_HOA_DON_ENDPOINT}`),
  Insert: (payload: IKyHieuHoaDon) =>
    apiClient.post(`${KY_HIEU_HOA_DON_ENDPOINT}`, payload),
  Update: (payload: IKyHieuHoaDon) =>
    apiClient.put(`${KY_HIEU_HOA_DON_ENDPOINT}`, payload),
  Delete: (id: number) => apiClient.delete(`${KY_HIEU_HOA_DON_ENDPOINT}/${id}`),
};
